import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class JwtService {
  getToken(): string | null {
    return window.localStorage.getItem('token');
  }

  saveToken(token: string | undefined | null) {
    window.localStorage.setItem('token', token ?? '');
  }

  saveAccessToken(token: string | undefined | null) {
    window.localStorage.setItem('access_token', token ?? '');
  }

  getAccessToken(): string | null {
    return window.localStorage.getItem('access_token');
  }

  destroyToken() {
    window.localStorage.removeItem('token');
    window.localStorage.removeItem('access_token');
  }
}
